/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">企業管理者画面</div>
            <div class="store_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue">
                <form class="form_checkSetting">

                    <div class="wd720">
                        <p v-if="this.viewtype== 'day1'" class="checkSetting_text">TOPボタンA メニュー画面 {{this.buttonname}}  ページNo{{this.page}}</p>
                        <p v-else-if="this.viewtype== 'day2'" class="checkSetting_text">TOPボタンD メニュー画面 {{this.buttonname}}  ページNo{{this.page}}</p>
                    </div><br>

                    <div class="wd720" v-show="!monthlyCheckButtonId">
                        <div class="row">
                            <div class="col-7"></div>
                            <div class="col-3">
                                <a href="https://www.haccp-station-manual.com/" target="_blank" rel="noopener noreferrer" class="icn_back_black router-link-active">
                                    <p class="monthly_help">ヘルプ</p>
                                </a>
                            </div>
                        </div>
                        <p class="monthly_text">不定期帳票の詳細設定はこちらをご参照ください</p>
                    </div>

                    <div class="wd720">
                        <Message v-if="apivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
                        <Message v-if="apivalidationMessage" :validationMessage="apivalidationMessage" />
                    </div>


                    <div class="lavel_store right_comment" style="vertical-align: middle">
                        <label for="releaseSelect">リリース日</label>
                    </div>
                    <div class="input_store left_comment selectFile" id="releaseSelect">
                        <select  v-model="applyStartDate" class="wd250" @change="init">
                            <option v-for="releaseHistorie in releaseHistories" :key="releaseHistorie" :value="releaseHistorie">
                                {{releaseHistorie}}</option>
                        </select>
                        <label class="selectFile__label">取消<input type="button" id="arrangement15" @click="releaseDayDelete"><br></label>
                        <p id="button_del_err" class="lavel_error_font ">{{validation.startDataResult}}</p>
                    </div>

                    <div class="lavel_store right_comment">
                        <img  class="required" src="../assets/required.png" />
                        <label for="releaseInput">リリース日を入力</label>
                    </div>
                    <div class="input_store left_comment" id="releaseInput">
                        <div class="wd250" >
                            <v-date-picker ref="picker" v-model="date" mode="single" :masks="{ input: ['YYYY/MM/DD']}" :min-date="vDatePickerMinDay">
                            </v-date-picker>
                        </div>
                        <label id="button_re_err" class="lavel_error_font ">{{validation.dataResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="displaySet">表示設定</label>
                    </div>
                    <div class="input_store left_comment" id="displaySet">
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="displaySet_id1" name="checkdis" type="radio" value='1'  v-model="dailyCheckPageSettings.displayFlg">
                            <label class="form-check-label" for="displaySet_id1">表示</label>
                        </div>
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="displaySet_id2" name="checkdis" type="radio" value='0' v-model="dailyCheckPageSettings.displayFlg" @change="selectDisplaySetting">
                            <label class="form-check-label" for="displaySet_id2">非表示</label>
                        </div>
                        <br>
                        <label id="diesplaySet_id_err" class="lavel_error_font ">{{validation.displayFlgResult}}</label>
                    </div>


                    <div class="lavel_store right_comment">
                        <label for="displaySet">表示曜日</label>
                    </div>
                    <div class="input_store left_comment" id="displaySetB">
                        <div class="form-check-inline mgr_30">
                            <input type="checkbox" class="mgr_5 temperature_checkBox" id="02-A" name="weekbox01" v-model="weekSelect.allSelected" @change="selectOn">
                            <label for="02-A" class="mgr_10">すべて</label>
                        </div>
                        <div class="form-check-inline mgr_25">
                            <input type="checkbox" class="mgr_5 temperature_checkBox" id="02-B" name="weekbox01" v-model="weekDisplayFlg.sunday">
                            <label for="02-B" class="lavel_week_font">日</label>
                        </div>
                        <div class="form-check-inline mgr_25">
                            <input type="checkbox" class="mgr_5 temperature_checkBox" id="02-C" name="weekbox01" v-model="weekDisplayFlg.monday">
                            <label for="02-C">月</label>
                        </div>
                        <div class="form-check-inline mgr_25">
                            <input type="checkbox" class="mgr_5 temperature_checkBox" id="02-D" name="weekbox01" v-model="weekDisplayFlg.tuesday">
                            <label for="02-D">火</label>
                        </div>
                        <div class="form-check-inline mgr_25">
                            <input type="checkbox" class="mgr_5 temperature_checkBox" id="02-E" name="weekbox01" v-model="weekDisplayFlg.wednesday">
                            <label for="02-E">水</label>
                        </div>
                        <div class="form-check-inline mgr_25">
                            <input type="checkbox" class="mgr_5 temperature_checkBox" id="02-F" name="weekbox01" v-model="weekDisplayFlg.thursday">
                            <label for="02-F">木</label>
                        </div>
                        <div class="form-check-inline mgr_25">
                            <input type="checkbox" class="mgr_5 temperature_checkBox" id="02-G" name="weekbox01" v-model="weekDisplayFlg.friday">
                            <label for="02-G">金</label>
                        </div>
                        <div class="form-check-inline mgr_25">
                            <input type="checkbox" class="mgr_5 temperature_checkBox" id="02-H" name="weekbox01" v-model="weekDisplayFlg.saturday">
                            <label for="02-H">土</label>
                        </div>
                    </div>


                    <div class="lavel_store right_comment">
                        <img v-if="dailyCheckPageSettings.displayFlg == 1" class="required" src="../assets/required.png" />
                        <label for="button_name">タイトル</label>
                    </div>
                    <div class="input_store left_comment">
                        <input class="wd400"  id="button_name" name="buttonname" type="text" v-model="dailyCheckPageSettings.dailyCheckPageName" maxlength="22" /><br>
                        <label id="button_name_err" class="lavel_error_font ">{{validation.titleResult}}</label>
                    </div>


                    <div class="lavel_check_setting right_comment ">
                        <label for="manual">マニュアル</label>
                    </div>
                    <div class="input_store left_comment selectFile">
                        <input v-if="this.manualFile == null" class="wd400" id="manual" name="manual" type="text" disabled />
                        <input v-else-if="this.manualFile !== null" class="wd400" id="manual2" name="manual" type="text" disabled v-model="manualFile['name']" />
                        <label class="selectFile__label">選択<input ref="manual" type="file" accept="image/jpeg, image/jpg, image/png, image/gif,.pdf" @change="selectManualFiles($event)" />
                        </label>
                        <p id="manual_fill_name1" class="wd400 text_white_space_nowrap" style="display: inline-flex;">{{dailyCheckPageSettings.manualFilePath}}</p>
                        <label v-if="dailyCheckPageSettings.manualFilePath" class="selectFile__label" @click.prevent.stop="openDeleteModal(1)">削除</label><br>
                        <p id="manual_err" class="lavel_error_font ">{{validation.manualFilePathResult}}</p>
                    </div>

                    <div class="lavel_check_setting right_comment">
                        <label for="information">インフォメーション</label>
                    </div>
                    <div class="input_store left_comment selectFile">
                        <input v-if="this.informationFile == null" class="wd400" id="information" name="information" type="text" disabled  />
                        <input v-else-if="this.informationFile !== null" class="wd400" id="information2" name="information" type="text" disabled v-model="informationFile['name']" />
                        <label class="selectFile__label">選択<input ref="information" type="file" accept="image/jpeg, image/jpg, image/png, image/gif,.pdf" @change="selectInfoFiles($event)" />
                        </label>
                        <br>
                        <div class="">
                            <p id="info_fill_name" class="wd400 text_white_space_nowrap" style="display: inline-flex;">{{dailyCheckPageSettings.informationFilePath}}</p>
                            <label v-if="dailyCheckPageSettings.informationFilePath" class="selectFile__label" @click.prevent.stop="openDeleteModal(2)">削除</label><br>
                            <p id="information_err" class="lavel_error_font ">{{validation.informationFilePathResult}}</p>
                            <p>※マニュアル、インフォメーションについて画像(jpeg,jpg,png,gif)またはpdfのみ許可</p>
                            <p>※アップロードできるファイルサイズは500MBまでです</p>
                        </div>
                    </div>


                    <div class="lavel_check_setting right_comment">
                        <label for="arrangement">配置設定</label>
                    </div>
                    <div class="input_store left_comment selectFile">
                        <input v-if="this.arrangementFile == null" class="wd400" id="arrangement" name="information" type="text" disabled />
                        <input v-if="this.arrangementFile !== null" class="wd400" id="arrangement2" name="information" type="text" disabled v-model="arrangementFile['name']" />
                        <label class="selectFile__label">選択<input ref="arrangement" type="file" accept="image/jpeg, image/jpg, image/png" @change="selectArrangementFiles($event)"></label>
                        <label class="selectFile__label" v-if="this.arrangementFile == null ||
                        dailyCheckPageSettings.arrangementRuleSettings.length == 15">追加<input type="button" id="arrangement3" disabled><br></label>
                        <label class="selectFile__label" v-else-if="this.arrangementFile !== null">追加<input type="button" id="arrangement4" @click="selectAddFiles"><br></label>
                        <p id="arrangement_err" class="lavel_error_font ">{{validation.arrangementFileResult}}</p>
                    </div>


                    <div class="lavel_store right_comment">
                        <label for="arrangementList"></label>
                    </div>
                    <div  style="padding: 15px" id="arrangementList" name="pageSetting" >
                        <table class="checkSetting_tbl_unit">
                            <tbody>
                                <tr>
                                    <th class="wd100 checkSetting_text_align">表示順</th>
                                    <th class="wd400 checkSetting_text_align">ファイル名</th>
                                    <th class="wd100 checkSetting_text_align" >移動</th>
                                    <th class="wd100 checkSetting_text_align" >削除</th>
                                </tr>
                                <tr v-for="i in dailyCheckPageSettings.arrangementRuleSettings.length" :key=i>
                                    <td class="wd100 checkSetting_text_align">{{dailyCheckPageSettings.arrangementRuleSettings[i-1].arrangementRuleNo}}</td>
                                    <td class="wd400 text_white_space">{{dailyCheckPageSettings.arrangementRuleSettings[i-1].arrangementRuleFilePath}}</td>
                                    <td v-if="i == 1" class="wd100" style="text-align: center" >
                                        <input type="button" value="▼" @click="lowArrangement(i)">
                                    </td>
                                    <td v-else-if="i == dailyCheckPageSettings.arrangementRuleSettings.length" class="wd100" style="text-align: center" >
                                        <input type="button" value="▲" @click="upArrangement(i)"><br>
                                    </td>
                                    <td v-else class="wd100" style="text-align: center">
                                        <input type="button" value="▲" @click="upArrangement(i)"><br>
                                        <input type="button" value="▼" @click="lowArrangement(i)">
                                    </td>
                                    <td class="selectFile">
                                        <label class="selectFile__label" style="margin-left: 0; width: 89px;">
                                            削除<input type="button" @click="deleteArrangementFile(i)">
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="lavel_store right_comment">
                        <label for="allButtonDisplaySet">全て確認ボタン表示設定</label>
                    </div>
                    <div class="input_store left_comment" id="allButtonDisplaySet">
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="allButtonDisplaySet_id1" name="allbuttondisplaycheckdis" type="radio" value='1'  v-model="dailyCheckPageSettings.allButtonDisplayFlg">
                            <label class="form-check-label" for="allButtonDisplaySet_id1">表示</label>
                        </div>
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="allButtonDisplaySet_id2" name="allbuttondisplaycheckdis" type="radio" value='0' v-model="dailyCheckPageSettings.allButtonDisplayFlg">
                            <label class="form-check-label" for="allButtonDisplaySet_id2">非表示</label>
                        </div>
                        <br>
                        <label id="allButtonDisplaySet_id_err" class="lavel_error_font ">{{validation.allButtonDisplayFlgResult}}</label>
                    </div>
                    <div class="lavel_store right_comment">
                      <label for="alert_all_setting">アラート一括設定</label>
                      <input type="checkbox" name="checkbox02" id="alertAllSetting" v-model="isLump" :value="1" @change="chengIsLump">
                      <label class="checkbox02" for="alertAllSetting"></label>
                    </div>
                    <div class="input_store left_comment" id="alertAllSetting">
                      <input type="text" class="textbox_td_tyori text-left" readonly :disabled="isLump == 0" :value="lumpAlertSetting.format" @click.prevent.stop="clickLumpAlertSetting" style="border: 1px solid #949393;border-radius:5px;">
                    </div>
                    <div class="lavel_store right_comment">
                        <img v-if="dailyCheckPageSettings.displayFlg == 1"  class="required" src="../assets/required.png" /><br />
                        <label>チェック項目設定</label>
                    </div>
                    <div  style="padding: 15px" id="checkSetting" name="pageSetting" >
                        <table class="checkSetting_tbl_unit">
                            <tbody>
                            <tr>
                                <th class="wd100 checkSetting_text_align">表示順</th>
                                <th class="wd400 checkSetting_text_align">チェック内容</th>
                                <th class="wd70 checkSetting_text_align">アラート通知</th>
                                <th class="wd70 checkSetting_text_align" >アラート通知時間</th>
                                <th v-show="monthlyCheckButtonId" class="wd100 checkSetting_text_align" >移動</th>
                                <th class="wd100 checkSetting_text_align" >コメント欄</th>
                            </tr>
                            <tr v-for="(dailyCheckItemList, index) in dailyCheckItemLists" :key=dailyCheckItemList.dailyCheckItemNo>
                                <td class="wd100 checkSetting_text_align">{{dailyCheckItemList.dailyCheckItemNo}}</td>
                                <td class="wd400 view_setting_text_td">
                                    <input type="text" class="view_setting_text_input w-100 h-100" v-model="dailyCheckItemList.dailyCheckItemName" maxlength="30">
                                </td>
                                <td class="checkSetting_text_align">
                                    <select v-model="dailyCheckItemList.alertSetting.isSet" class="select_height">
                                        <option :value="1" >有</option>
                                        <option :value="0" >無</option>
                                    </select>
                                </td>
                                <td class="wd70 view_setting_text_td">
                                    <input type="text" class="textbox_td_tyori text-left" readonly :disabled="isLump == 1" :value="dailyCheckItemList.alertSetting.format" @click.prevent.stop="clickAlertSetting(index)" style="border: 1px solid #949393;border-radius:5px;">
                                </td>
                                <td v-if="dailyCheckItemList.dailyCheckItemNo == 1" v-show="monthlyCheckButtonId" class="wd100" style="text-align: center" >
                                    <input type="button" value="▼" @click="lowdailyCheckItemNo(dailyCheckItemList.dailyCheckItemNo)">
                                </td>
                                <td v-else-if="dailyCheckItemList.dailyCheckItemNo == 50" v-show="monthlyCheckButtonId" class="wd100" style="text-align: center" >
                                    <input type="button" value="▲" @click="updailyCheckItemNo(dailyCheckItemList.dailyCheckItemNo)"><br>
                                </td>
                                <td v-else v-show="monthlyCheckButtonId" class="wd100" style="text-align: center">
                                    <input type="button" value="▲" @click="updailyCheckItemNo(dailyCheckItemList.dailyCheckItemNo)"><br>
                                    <input type="button" value="▼" @click="lowdailyCheckItemNo(dailyCheckItemList.dailyCheckItemNo)">
                                </td>

                                <td class=" checkSetting_buttan_unit checkSetting_kanri_comment_box checkSetting_text_align">
                                  <ul class="ul_tbl_buttan">
                                    <li>
                                      <a href="#" @click.prevent.stop="commentDisplayFlgToggle(dailyCheckItemList.dailyCheckItemNo)" v-if="dailyCheckItemList.commentDisplayFlg" style="background-color: #F5C239;">表示</a>
                                      <a href="#" @click.prevent.stop="commentDisplayFlgToggle(dailyCheckItemList.dailyCheckItemNo)" v-else style="background-color: #FFFFFF;">非表示</a>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                        <p id="checkSetting_err" class="lavel_error_font ">{{validation.checkSettingResult}}</p>
                    </div>

                </form><br>
            </div>
            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="cancel">キャンセル</a></li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="releaseDayUpAdd">更新</a></li>
                    </ul>
                    <ul v-if="dailyCheckPageSettings.displayFlg == 1" class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit btn_preview_color" href="#" @click.prevent.stop="openPreview">プレビュー</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd570">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p v-if="showContentKbn == 1" class="modal_header_tit">ページ編集 新規登録</p>
                            <p v-if="showContentKbn == 2" class="modal_header_tit">ページ編集 更新確認</p>
                            <p v-if="showContentKbn == 3" class="modal_header_tit">ページ編集 取消確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p v-if="showContentKbn == 1 && date !== null">リリース日{{selectDateFormat(this.date)}}の設定を新規登録します。<br>よろしいですか？
                            <br><br>現時点での表示設定に戻ります。<br>登録/更新した情報を確認する場合には、上部「リリース日」にて日付を選択してください。</p>
                        <p v-if="showContentKbn == 2 && updateKbn ==1 && date !== null">リリース日{{selectDateFormat(this.date)}}の設定を更新します。<br>よろしいですか？
                            <br><br>現時点での表示設定に戻ります。<br>登録/更新した情報を確認する場合には、上部「リリース日」にて日付を選択してください。</p>
                        <p v-if="showContentKbn == 3">リリース日{{applyStartDate}}の設定を取消します。<br>よろしいですか？</p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeModelDelete">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a v-if="showContentKbn == 1" href="#" @click.prevent.stop="openModel">OK</a>
                            <a v-if="showContentKbn == 2" href="#" @click.prevent.stop="openModel">OK</a>
                            <a v-if="showContentKbn == 3" href="#" @click.prevent.stop="delModel">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent3">
            <div>
                <div class="modal_box wd570">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p v-if="showContentKbn == 1" class="modal_header_tit">ページ編集 新規登録</p>
                            <p v-if="showContentKbn == 2" class="modal_header_tit">ページ編集 更新確認</p>
                            <p v-if="showContentKbn == 3" class="modal_header_tit">ページ編集 取消確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p v-if="showContentKbn == 1">登録しました。</p>
                        <p v-if="showContentKbn == 2">更新しました。</p>
                        <p v-if="showContentKbn == 3">取消しました。</p>
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="closeModelComp">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent4">
          <div>
            <div class="modal_box wd570">
              <div class="modal_header_unit">
                <div class="modal_header_box">
                  <p class="modal_header_tit">アラート通知設定</p>
                </div>
              </div>
              <div class="modal_content_tex">
                <div class="modal_alert_setting_box">
                  <div class="model_alert_setting_item">
                    <div class="wd45 align-items-center"></div>
                    <label class="mgl_10 mgr_10">設定:</label>
                    <input type="text" class="wd200 textbox_td_tyori text-left" readonly v-model="alertSetting.format" style="border: 1px solid #949393;border-radius:5px;">
                  </div>
                  <div class="model_alert_setting_item">
                    <div class="wd45 align-items-center"></div>
                    <label class="mgl_10 mgr_10" >時間:</label>
                    <vue-timepicker @change="changeFormat" input-width="200px"  minute-interval="60" v-model="alertSetting.time" :hide-clear-button="true"></vue-timepicker>
                  </div>
                  <div class="model_alert_setting_item">
                    <input class="wd45" type="radio" name="checkbox02" id="repeat0" v-model="alertSetting.repeat_type" :value='0' @change="changeFormat">
                    <label class="mgl_10 mgr_10 form-check-label" for="repeat_type">毎日:</label>
                    <div class="wd200" >{{alertSetting.time}}</div>
                  </div>
                  <div class="model_alert_setting_item">
                    <input class="wd45" type="radio" name="checkbox02" id="repeat1" v-model="alertSetting.repeat_type" :value='1' @change="changeFormat">
                    <label class="mgl_10 mgr_10">曜日:</label>
                    <select class="wd200"  v-model="alertSetting.weekday" @change="changeFormat">
                      <option v-for="d in weekdays" :key="d.value" :value="d.value">{{ d.text }}</option>
                    </select>
                  </div>
                  <div class="model_alert_setting_item">
                    <input class="wd45" type="radio" name="checkbox02" id="repeat2" v-model="alertSetting.repeat_type" :value='2' @change="changeFormat">
                    <label class="mgl_10 mgr_10">毎月:</label>
                    <select class="wd90"  v-model="alertSetting.monthday" @change="changeFormat">
                      <option v-for="d in monthdays" :key="d.value" :value="d.value">{{ d.text }}</option>
                    </select>
                    <select class="wd90 mgl_10"  v-model="alertSetting.monthday_second" @change="changeFormat">
                      <option v-for="d in monthdays" :key="d.value" :value="d.value">{{ d.text }}</option>
                    </select>
                    <button class="mgl_10" style="height: 20px;display: flex;align-items: center;border: 1px solid #c4bfbf;" @click="clearMonthday">x</button>
                  </div>

                </div>
              </div>

              <div class="btn_submit_box">
                <div class="btn_submit2">
                  <a href="#" @click.prevent.stop="closeAlertSettingModel">キャンセル</a>
                </div>
                <div class="btn_submit">
                  <a href="#" @click.prevent.stop="setAlertSetting">OK</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
        <div class="overlay" v-show="showDeleteContent1">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">{{deleteFileName}}削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>{{deleteFileName}}を削除しますか？
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeDeleteModal1">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="deleteFile">削除</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showDeleteContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">{{deleteFileName}}削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>{{deleteFileName}}削除が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeDeleteModal2">OK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import PulseLoader from '@/app/components/PulseLoader.vue'
import Message from '@/app/components/Message.vue'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
    name: 'CheckViewSettingPage',
    components: {
        PulseLoader,
        Message,
        VueTimepicker,
    },
    data: function () {
        return {
            vDatePickerMinDay:null,
            weekSelect:{
                allSelected:false,
            },
            updateKbn:0,
            showContentKbn:null,
            showContent4:false,
            showContent3:false,
            showContent2:false,
            applyStartDate:null,
            releaseHistories:[],
            date:null,
            isLoading:false,
            isInitLoading:true,
            apivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            brandId: '',
            count:20,
            showContent:false,
            manualFile:null,
            informationFile:null,
            arrangementFile:null,
            dailyCheckItemLists:[
                {   dailyCheckItemId:null,
                    dailyCheckItemNo:null,
                    dailyCheckItemName:'',
                    commentDisplayFlg:false,
                    alertSetting:{
                      format:'毎日 00:00',
                      isSet: 0,
                      time:'00:00',
                      repeat_type: 0,
                      weekday: 0,
                      monthday: 1,
                      monthday_second: null,
                    }
                }
            ],
            dailyCheckPageSettings: {
                dailyCheckItemSettings: [],
                arrangementRuleSettings: [],
                displayFlg: null,
                allButtonDisplayFlg:null,
            },
            validation:{
                displayFlgResult:"",
                titleResult:"",
                manualFilePathResult:"",
                informationFilePathResult:"",
                checkSettingResult:"",
                arrangementFileResult:"",
                dataResult:"",
                startDataResult:"",
                allButtonDisplayFlgResult: "",
            },
            addFormFlg: true,
            showDeleteContent1: false,
            showDeleteContent2: false,
            deleteFileType: "",
            deleteFileName: "",
            weekDisplayFlg:{
                sunday: true,
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true
            },
          alertSetting: {
            format:'毎日 00:00',
            isSet: 0,
            time:'00:00',
            repeat_type: 0,
            weekday: 0,
            monthday: 1,
            monthday_second: null,
          },
          lumpAlertSetting: {
            format:'毎日 00:00',
            isSet: 0,
            time:'00:00',
            repeat_type: 0,
            weekday: 0,
            monthday: 1,
            monthday_second: null,
          },
          weekdays: [
            { text: '月', value: 1 },
            { text: '火', value: 2 },
            { text: '水', value: 3 },
            { text: '木', value: 4 },
            { text: '金', value: 5 },
            { text: '土', value: 6 },
            { text: '日', value: 0 },
          ],
          monthdays: [
            { text: '1日', value: 1 }, { text: '2日', value: 2 }, { text: '3日', value: 3 }, { text: '4日', value: 4 },
            { text: '5日', value: 5 }, { text: '6日', value: 6 }, { text: '7日', value: 7 }, { text: '8日', value: 8 },
            { text: '9日', value: 9 }, { text: '10日', value: 10 }, { text: '11日', value: 11 }, { text: '12日', value: 12 },
            { text: '12日', value: 13 }, { text: '14日', value: 14 }, { text: '15日', value: 15 }, { text: '16日', value: 16 },
            { text: '17日', value: 17 }, { text: '18日', value: 18 }, { text: '19日', value: 19 }, { text: '20日', value: 20 },
            { text: '21日', value: 21 }, { text: '22日', value: 22 }, { text: '23日', value: 23 }, { text: '24日', value: 24 },
            { text: '25日', value: 25 }, { text: '26日', value: 26 },{ text: '27日', value: 27 }, { text: '28日', value: 28 },
            { text: '29日', value: 29 }, { text: '30日', value: 30 },{ text: '31日', value: 31 }, { text: '月末', value: 0 },
          ],
          isLump:0,
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        id: function () {
            return this.$store.getters['checkPage/dailyCheckPageId']
        },
        viewtype: function () {
            return this.$store.getters['checkPage/viewType']
        },
        bottunid: function () {
            return this.$store.getters['checkPage/buttonId']
        },
        buttonname: function () {
            return this.$store.getters['checkPage/buttonName']
        },
        page: function () {
            return this.$store.getters['checkPage/dailyCheckPageNo']
        },
        menuId () {
            return Number(this.$store.getters['checkPage/menuId'])
        },
        subMenuId () {
            return Number(this.$store.getters['checkPage/id'])
        },
        monthlyCheckButtonId: function () {
            return this.bottunid === 99 ? false : true;
        },
    },
    created: function(){
        this.calc();
    },
    methods:{
        async calc(){

            var apiResponseFlg = true;
            this.isInitLoading = true;

            // 企業IDを取得
            this.brandId = this.$store.getters['brand/id'];
            var applyStartDate = "";

            // パラメータ初期化
            this.date = null;
            this.clearError();
            this.addFormFlg = true;
            this.weekSelect.allSelected = false;

            // 取得する日付を指定
            if(this.applyStartDate !== null){
                applyStartDate = this.applyStartDate;
            }

            // datepikerの日付を成形(翌日日付け)
            this.vDatePickerMinDay = this.checkDateBusinessDay();

            // メニューページ情報取得API
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/page/' + this.id, { params: { apply_start_date:applyStartDate}})
                .then(response => (this.dailyCheckPageSettings = response.data,
                        this.releaseHistories = response.data.releaseHistories,
                        this.applyStartDate = response.data.applyStartDate
                ))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);
            if(apiResponseFlg){
                this.dailyItemData();
            }
        },
        openPreview() {
            this.isLoading = true;

            // バリデーションチェック
            this.validationCheckForPreview();
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            this.$store.dispatch('preview/setPreviewItems', this.getPreviewItems());

            //別タブ表示
            let routeData = this.$router.resolve({name: 'dailyCheckMenuInputPreview', params: {menuId: this.menuId, subMenuId: this.subMenuId}});
            window.open(routeData.href, '_blank');
            this.isLoading = false;
        },
        getPreviewItems() {
            let previewItems = {
                pageId: this.id,
                dailyCheckPageName: this.dailyCheckPageSettings.dailyCheckPageName,
                dailyCheckItemNames: [],
                dailyCheckItemCommentDisplayFlg:[],
                arrangementRuleCount: this.dailyCheckPageSettings.arrangementRuleSettings.length,
                allButtonDisplayFlg:this.dailyCheckPageSettings.allButtonDisplayFlg,
            };
            this.dailyCheckItemLists.forEach(dailyCheckItemSetting => {
                if (dailyCheckItemSetting.dailyCheckItemName != '') {
                    previewItems.dailyCheckItemNames.push(dailyCheckItemSetting.dailyCheckItemName);
                    previewItems.dailyCheckItemCommentDisplayFlg.push(dailyCheckItemSetting.commentDisplayFlg);
                }
            });
            return previewItems;
        },
        async openModel() {

            this.isLoading = true;
            var apiResponseFlg = true;
            this.apivalidationMessage = '';
            this.showContent2 = false;

            // radioボタンを取得
            var radioButtons = document.getElementsByName( "checkdis" ) ;

            // 選択状態の値を取得
            var checkedValue = ""
            for (var i=0; i < radioButtons.length; i++) {
                if ( radioButtons[i].checked ) {
                    checkedValue = radioButtons[i].value ;
                    break ;
                }
            }
            if ( checkedValue === "" ) {
                // 未選択状態
                checkedValue = false
            }
            // radioボタンを取得
            var allButtonDisplayRadioButtons = document.getElementsByName( "allbuttondisplaycheckdis" ) ;
            // 選択状態の値を取得
            var allButtonDisplayCheckedValue = ""
            for (var j=0; j < allButtonDisplayRadioButtons.length; j++) {
                if ( allButtonDisplayRadioButtons[j].checked ) {
                    allButtonDisplayCheckedValue = allButtonDisplayRadioButtons[j].value ;
                    break ;
                }
            }
            if ( allButtonDisplayCheckedValue === "" ) {
                // 未選択状態
                allButtonDisplayCheckedValue = false
            }
            // request作成
            var requestBody = {
                daily_check_page_name: this.dailyCheckPageSettings.dailyCheckPageName,
                display_flg: checkedValue,
                all_button_display_flg:allButtonDisplayCheckedValue,
            }
            if (this.manualFile != null) {
                requestBody.manual_file_path = this.manualFile
            }
            if (this.informationFile != null) {
                requestBody.information_file_path = this.informationFile
            }
            var arrangement_rule_settings = [];
            this.dailyCheckPageSettings.arrangementRuleSettings.forEach(arrangementRuleSetting => {
                var arrangement_rule_setting = {}
                if(arrangementRuleSetting.arrangementRuleId == '') {
                    arrangement_rule_setting.arrangement_rule_no = arrangementRuleSetting.arrangementRuleNo;
                    arrangement_rule_setting.arrangement_rule_file_path = arrangementRuleSetting.arrangementFileObj;
                } else {
                    arrangement_rule_setting.arrangement_rule_id = arrangementRuleSetting.arrangementRuleId;
                    arrangement_rule_setting.arrangement_rule_no = arrangementRuleSetting.arrangementRuleNo;
                }
                arrangement_rule_settings.push(arrangement_rule_setting);
            });
            requestBody.arrangement_rule_settings = arrangement_rule_settings;
            var daily_check_item_settings = [];
            this.dailyCheckItemLists.forEach(dailyCheckItemSetting => {
                var arrangement_rule_setting = {
                    daily_check_item_id: dailyCheckItemSetting.dailyCheckItemId,
                    daily_check_item_no: dailyCheckItemSetting.dailyCheckItemNo,
                    daily_check_item_name: dailyCheckItemSetting.dailyCheckItemName,
                    comment_display_flg: dailyCheckItemSetting.commentDisplayFlg,
                    alertSetting: dailyCheckItemSetting.alertSetting,
                }
                daily_check_item_settings.push(arrangement_rule_setting);
            });
            requestBody.daily_check_item_settings = daily_check_item_settings;

            // 連携する日付を設定
            requestBody.apply_start_date = this.selectDateFormat(this.date);


            // 曜日の変換
            this.weekDisplayFlg.sunday = this.weekDisplayFlg.sunday == true ? 1:0;
            this.weekDisplayFlg.monday = this.weekDisplayFlg.monday == true ? 1:0;
            this.weekDisplayFlg.tuesday = this.weekDisplayFlg.tuesday == true ? 1:0;
            this.weekDisplayFlg.wednesday = this.weekDisplayFlg.wednesday == true ? 1:0;
            this.weekDisplayFlg.thursday = this.weekDisplayFlg.thursday == true ? 1:0;
            this.weekDisplayFlg.friday = this.weekDisplayFlg.friday == true ? 1:0;
            this.weekDisplayFlg.saturday = this.weekDisplayFlg.saturday == true ? 1:0;

            requestBody.week_display_flg = this.weekDisplayFlg;

            requestBody.release_date = this.applyStartDate;

            var formRequestBody = this.jsonToFormData(requestBody);

            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data;'
                }
            }

            // メニューページ情報更新API
            await this.$axios
                .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/page/' + this.id, formRequestBody, config)
                .then(response => (this.dailyCheckPageSettings = response.data))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        // APIのエラー情報をerrorに入れる
                        error = Object.assign(error, err.customError)
                        // エラーコードが400であればバリデーションエラーなので画面に表示する
                        if (error.code == 400) {
                            this.apivalidationMessage = error.message
                            this.scrollTop();
                        }
                    }
                    if (this.apivalidationMessage == '') {
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            if(apiResponseFlg){
                this.dailyItemData();
                this.showContent3 = true;
            }
        },
        closeModel() {
            this.showContent = false;
        },
        openDeleteModal(fileType){
            if (this.applyStartDate <= this.selectDateFormat(new Date())) {
                // 日付のバリデーション
                switch(fileType) {
                    case 1:
                        this.validation.manualFilePathResult = "過去のマニュアルは削除できません。";
                        break;
                    case 2:
                        this.validation.informationFilePathResult = "過去のインフォメーションは削除できません。"
                        break;
                }
            } else {
                this.showDeleteContent1 = true;
                switch(fileType) {
                    case 1:
                        this.deleteFileName = "マニュアル";
                        this.deleteFileType = 'manual';
                        break;
                    case 2:
                        this.deleteFileName = "インフォメーション";
                        this.deleteFileType = 'information';
                        break;
                }
            }
        },
        async deleteFile() {
            this.showDeleteContent1 = false;
            this.isLoading = true;
            this.apivalidationMessage = '';

            let requestBody = {
                file_type: this.deleteFileType,
                date: this.applyStartDate,
            };
            let formRequestBody = this.jsonToFormData(requestBody);

            // メニューページファイル削除API
            await this.$axios
                .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/page/' + this.id + '/deleteFile', formRequestBody)
                .then(response => {
                    switch (this.deleteFileType) {
                        case 'manual':
                            this.dailyCheckPageSettings.manualFilePath = response.data.manualFilePath;
                            break;
                        case 'information':
                            this.dailyCheckPageSettings.informationFilePath = response.data.informationFilePath;
                            break;
                    }
                    this.showDeleteContent2 = true;
                })
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.apivalidationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> (this.isLoading = false));
        },
        closeDeleteModal1() {
            this.showDeleteContent1 = false;
        },
        closeDeleteModal2(){
            this.showDeleteContent2 = false;
        },
        //〇×ボタン押下時のlist書き換え用メソッド
        clickChech:function (event,itemId,indexCount) {

            //ボタン押下時のクリック制御
            var buttonCheckList = this.list[indexCount];
            if(buttonCheckList[itemId] != 2){
                var inCount = Number(buttonCheckList[itemId]);
                buttonCheckList[itemId] = inCount + 1;
            }
            else{
                buttonCheckList[itemId] = "";
            }

            this.list.splice(indexCount,1,buttonCheckList);
        },
        dailyItemData:function(){

            // デイリーデータの表示データを成形
            let itemList = [];
            for(var k = 0 ; k < 50 ; k++){
                var indexList = new Object();
                var settingFlg = false
                this.dailyCheckItemLists = [];
                for( var i=0 ; i < this.dailyCheckPageSettings.dailyCheckItemSettings.length ; i++){
                    if(this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemNo == (k + 1)){
                        indexList['dailyCheckItemId']  = this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemId;
                        indexList['dailyCheckItemNo']  = this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemNo;
                        indexList['dailyCheckItemName']  = this.dailyCheckPageSettings.dailyCheckItemSettings[i].dailyCheckItemName;
                        indexList['commentDisplayFlg']  = this.dailyCheckPageSettings.dailyCheckItemSettings[i].commentDisplayFlg;

                        indexList['alertSetting'] = {
                          format:'毎日 00:00',
                          isSet: 0,
                          time:'00:00',
                          repeat_type: 0,
                          weekday: 0,
                          monthday: 1,
                          monthday_second: null,
                        };
                        if(this.dailyCheckPageSettings.dailyCheckItemSettings[i].alertId != null){
                          indexList['alertSetting'] = {
                            format:this.settingFormat(
                                this.dailyCheckPageSettings.dailyCheckItemSettings[i].repeatType,
                                this.dailyCheckPageSettings.dailyCheckItemSettings[i].weekday,
                                this.dailyCheckPageSettings.dailyCheckItemSettings[i].monthday,
                                this.dailyCheckPageSettings.dailyCheckItemSettings[i].monthdaySecond,
                                this.dailyCheckPageSettings.dailyCheckItemSettings[i].checkTime) ,
                            isSet: this.dailyCheckPageSettings.dailyCheckItemSettings[i].status,
                            time:this.dailyCheckPageSettings.dailyCheckItemSettings[i].checkTime,
                            repeat_type: this.dailyCheckPageSettings.dailyCheckItemSettings[i].repeatType,
                            weekday: this.dailyCheckPageSettings.dailyCheckItemSettings[i].weekday,
                            monthday: this.dailyCheckPageSettings.dailyCheckItemSettings[i].monthday,
                            monthday_second: this.dailyCheckPageSettings.dailyCheckItemSettings[i].monthdaySecond,
                          };
                        }
                        settingFlg = true;
                        break;
                    }
                }
                if(settingFlg == false){
                    indexList['dailyCheckItemId']  = null;
                    indexList['dailyCheckItemNo']  = k + 1;
                    indexList['dailyCheckItemName']  = '';
                    indexList['commentDisplayFlg']  = 0;
                    indexList['alertSetting'] = {
                      format:'毎日 00:00',
                      isSet: 0,
                      time:'00:00',
                      repeat_type: 0,
                      weekday: 0,
                      monthday: 1,
                      monthday_second: null,
                    };
                }
                itemList.push(indexList);
            }
            this.dailyCheckItemLists = itemList;

            // 曜日の変換
            this.weekDisplayFlg.sunday = Boolean(this.dailyCheckPageSettings.weekDisplayFlg.sunday);
            this.weekDisplayFlg.monday = Boolean(this.dailyCheckPageSettings.weekDisplayFlg.monday);
            this.weekDisplayFlg.tuesday = Boolean(this.dailyCheckPageSettings.weekDisplayFlg.tuesday);
            this.weekDisplayFlg.wednesday = Boolean(this.dailyCheckPageSettings.weekDisplayFlg.wednesday);
            this.weekDisplayFlg.thursday = Boolean(this.dailyCheckPageSettings.weekDisplayFlg.thursday);
            this.weekDisplayFlg.friday = Boolean(this.dailyCheckPageSettings.weekDisplayFlg.friday);
            this.weekDisplayFlg.saturday = Boolean(this.dailyCheckPageSettings.weekDisplayFlg.saturday);

        },
        updailyCheckItemNo:function (dailyCheckItemNo) {
            var upList = [];
            var lowList = [];
            upList["dailyCheckItemId"] = this.dailyCheckItemLists[dailyCheckItemNo-1].dailyCheckItemId;
            upList["dailyCheckItemNo"] = this.dailyCheckItemLists[dailyCheckItemNo-1].dailyCheckItemNo-1;
            upList["dailyCheckItemName"] = this.dailyCheckItemLists[dailyCheckItemNo-1].dailyCheckItemName;
            upList["commentDisplayFlg"] = this.dailyCheckItemLists[dailyCheckItemNo-1].commentDisplayFlg
            upList["alertSetting"] = this.dailyCheckItemLists[dailyCheckItemNo-1].alertSetting;
            lowList["dailyCheckItemId"] = this.dailyCheckItemLists[dailyCheckItemNo-2].dailyCheckItemId;
            lowList["dailyCheckItemNo"] = this.dailyCheckItemLists[dailyCheckItemNo-2].dailyCheckItemNo+1;
            lowList["dailyCheckItemName"] = this.dailyCheckItemLists[dailyCheckItemNo-2].dailyCheckItemName;
            lowList["commentDisplayFlg"] = this.dailyCheckItemLists[dailyCheckItemNo-2].commentDisplayFlg
            lowList["alertSetting"] = this.dailyCheckItemLists[dailyCheckItemNo-2].alertSetting;
            //配列に反映
            this.dailyCheckItemLists.splice(dailyCheckItemNo-2,1,upList);
            this.dailyCheckItemLists.splice(dailyCheckItemNo-1,1,lowList);

        },
        lowdailyCheckItemNo:function (dailyCheckItemNo) {
            var upList = [];
            var lowList = [];
            upList["dailyCheckItemId"] = this.dailyCheckItemLists[dailyCheckItemNo].dailyCheckItemId;
            upList["dailyCheckItemNo"] = this.dailyCheckItemLists[dailyCheckItemNo].dailyCheckItemNo-1;
            upList["dailyCheckItemName"] = this.dailyCheckItemLists[dailyCheckItemNo].dailyCheckItemName;
            upList["commentDisplayFlg"] = this.dailyCheckItemLists[dailyCheckItemNo].commentDisplayFlg
            upList["alertSetting"] = this.dailyCheckItemLists[dailyCheckItemNo].alertSetting;
            lowList["dailyCheckItemId"] = this.dailyCheckItemLists[dailyCheckItemNo-1].dailyCheckItemId;
            lowList["dailyCheckItemNo"] = this.dailyCheckItemLists[dailyCheckItemNo-1].dailyCheckItemNo+1;
            lowList["dailyCheckItemName"] = this.dailyCheckItemLists[dailyCheckItemNo-1].dailyCheckItemName;
            lowList["commentDisplayFlg"] = this.dailyCheckItemLists[dailyCheckItemNo-1].commentDisplayFlg
            lowList["alertSetting"] = this.dailyCheckItemLists[dailyCheckItemNo-1].alertSetting;
            //配列に反映
            this.dailyCheckItemLists.splice(dailyCheckItemNo-1,1,upList);
            this.dailyCheckItemLists.splice(dailyCheckItemNo,1,lowList);
        },
        upArrangement:function (arrangementRuleNo) {
            var upList = [];
            var lowList = [];
            upList["arrangementRuleId"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-1].arrangementRuleId;
            upList["arrangementRuleNo"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-1].arrangementRuleNo-1;
            upList["arrangementRuleFilePath"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-1].arrangementRuleFilePath;
            upList["arrangementFileObj"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-1].arrangementFileObj;
            lowList["arrangementRuleId"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-2].arrangementRuleId;
            lowList["arrangementRuleNo"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-2].arrangementRuleNo+1;
            lowList["arrangementRuleFilePath"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-2].arrangementRuleFilePath;
            lowList["arrangementFileObj"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-2].arrangementFileObj;
            //配列に反映
            this.dailyCheckPageSettings.arrangementRuleSettings.splice(arrangementRuleNo-2,1,upList);
            this.dailyCheckPageSettings.arrangementRuleSettings.splice(arrangementRuleNo-1,1,lowList);

        },
        lowArrangement:function (arrangementRuleNo) {
            var upList = [];
            var lowList = [];
            upList["arrangementRuleId"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo].arrangementRuleId;
            upList["arrangementRuleNo"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo].arrangementRuleNo-1;
            upList["arrangementRuleFilePath"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo].arrangementRuleFilePath;
            upList["arrangementFileObj"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo].arrangementFileObj;
            lowList["arrangementRuleId"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-1].arrangementRuleId;
            lowList["arrangementRuleNo"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-1].arrangementRuleNo+1;
            lowList["arrangementRuleFilePath"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-1].arrangementRuleFilePath;
            lowList["arrangementFileObj"] = this.dailyCheckPageSettings.arrangementRuleSettings[arrangementRuleNo-1].arrangementFileObj;
            //配列に反映
            this.dailyCheckPageSettings.arrangementRuleSettings.splice(arrangementRuleNo-1,1,upList);
            this.dailyCheckPageSettings.arrangementRuleSettings.splice(arrangementRuleNo,1,lowList);
        },
        selectManualFiles:function(event) {
            this.validation.manualFilePathResult = '';
            this.manualFile = null;
            let files = event.target.files[0];
            this.addFormFlg = true;

            // ファイル名の長さをチェック
            if(String(files['name']).length > 260){
                this.validation.manualFilePathResult = "ファイル名(拡張子を含む)は、260桁以内で入力してください。";
                this.addFormFlg = false;
                this.scrollTop();
                return null;
            }

            this.manualFile = files;
        },
        selectInfoFiles:function(event) {
            this.validation.informationFilePathResult = '';
            this.informationFile = null;
            let files = event.target.files[0];
            this.addFormFlg = true;

            // ファイル名の長さをチェック
            if(String(files['name']).length > 260){
                this.validation.informationFilePathResult = "ファイル名(拡張子を含む)は、260桁以内で入力してください。";
                this.addFormFlg = false;
                this.scrollTop();
                return null;
            }

            this.informationFile = files;
        },
        selectArrangementFiles:function(event) {
            this.validation.arrangementFileResult = '';
            var leg = this.dailyCheckPageSettings.arrangementRuleSettings.length;
            this.addFormFlg = true;

            // 配置ルールは10個まで登録
            if(leg >= 10){
                this.validation.arrangementFileResult = "配置ルールの登録は、10個までとなります。";
                this.addFormFlg = false;
                this.scrollTop();
                return null;
            }

            this.arrangementFile = null;
            let files = event.target.files[0];

            // ファイル名の長さをチェック
            if(String(files['name']).length > 260){
                this.validation.arrangementFileResult = "ファイル名(拡張子を含む)は、260桁以内で入力してください。";
                this.addFormFlg = false;
                this.scrollTop();
                return null;
            }

            this.arrangementFile = files;
        },
        selectAddFiles:function () {
            var leg = this.dailyCheckPageSettings.arrangementRuleSettings.length;
            var indexList = new Object();
            indexList['arrangementRuleId']  = '';
            indexList['arrangementRuleNo']  = leg+1;
            indexList['arrangementRuleFilePath']  = this.arrangementFile['name'];
            indexList['arrangementFileObj']  = this.arrangementFile;
            this.dailyCheckPageSettings.arrangementRuleSettings.push(indexList)
            this.arrangementFile = null;
            this.$refs.arrangement.value = '';
        },
        // 配置ルール削除
        deleteArrangementFile(arrangementRuleNo) {
            let deletedArrangementRuleList = this.dailyCheckPageSettings.arrangementRuleSettings
                .filter(arrangementRule => arrangementRule.arrangementRuleNo !== arrangementRuleNo);
            deletedArrangementRuleList.filter(arrangementRule => arrangementRule.arrangementRuleNo > arrangementRuleNo)
                .forEach(arrangementRule => {
                    arrangementRule.arrangementRuleNo -= 1;
                });
            this.dailyCheckPageSettings.arrangementRuleSettings = deletedArrangementRuleList;
        },
        cancel(){
            this.$router.push({name: 'manageCheckViewSetting',params:{ bottunid:this.bottunid }});
        },
        buildFormData(formData, data, parentKey) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                    this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
            } else {
                const value = data == null ? '' : data;

                formData.append(parentKey, value);
            }
        },
        jsonToFormData(data) {
            const formData = new FormData();

            this.buildFormData(formData, data);

            return formData;
        },
        validationCheckForPreview() {
            this.addFormFlg = true;

            //エラー内容初期化
            this.clearError();

            // 必須チェック
            this.validRequired();

            // 桁数オーバー
            this.validDigits();
        },
        validationCheck() {

            this.addFormFlg = true;

            //エラー内容初期化
            this.clearError();

            // 必須チェック
            this.validRequired();

            // 桁数オーバー
            this.validDigits();

            // リリース日の指定
            if(this.date == null){
                this.validation.dataResult="リリース日を入力してください。"
                this.addFormFlg = false;
                return;
            }

            // リリース日が現在、または過去の指定はNG
            if(this.selectDateFormat(this.date) <= this.chartDateBusinessDay(new Date())){
                this.validation.dataResult="リリース日指定は未来日を入力してください。"
                this.addFormFlg = false;
                return;
            }

            // 指定されたリリース日が半年以上の場合はNG
            var toDate = new Date()
            toDate.setDate(toDate.getDate()+180);
            if(this.selectDateFormat(this.date) > this.selectDateFormat(toDate)){
                this.validation.dataResult="リリース日は半年以内で入力してください。"
                this.addFormFlg = false;
                return;
            }
        },
        validRequired() {

            // 必須チェック
            if(this.dailyCheckPageSettings.displayFlg == 1){
                // チェック項目
                var checkSettingFlg = false;
                for(var i = 0 ; i < this.dailyCheckItemLists.length ; i++){
                    if(String(this.dailyCheckItemLists[i].dailyCheckItemName).length >= 1){
                        checkSettingFlg = true;
                        break;
                    }
                }

                if(!checkSettingFlg){
                    this.validation.checkSettingResult="チェック項目を入力してください。"
                    this.addFormFlg = false;
                }

                // タイトルテキスト
                if( !this.dailyCheckPageSettings.dailyCheckPageName){
                    this.validation.titleResult="タイトルを入力してください。"
                    this.addFormFlg = false;
                }
                //アラート通知時間
                for(var j = 0 ; j < this.dailyCheckItemLists.length ; j++){
                  if(this.dailyCheckItemLists[j].alertSetting.time === null || this.dailyCheckItemLists[j].alertSetting.time === undefined){
                    this.apivalidationMessage=this.dailyCheckItemLists[j].dailyCheckItemName+"のアラート通知時間を入力してください。";
                    this.addFormFlg = false;
                  }
                }
            }

            // 表示設定
            if(this.dailyCheckPageSettings.displayFlg == null){
                this.validation.displayFlgResult="表示設定を入力してください。"
                this.addFormFlg = false;
            }
            // 全て確認ボタン表示設定
            if(this.dailyCheckPageSettings.allButtonDisplayFlg == null){
                this.validation.allButtonDisplayFlgResult="全て確認ボタン表示設定を入力してください。"
                this.addFormFlg = false;
            }
        },
        validDigits() {
            //桁数オーバー
            // チェック項目
            for(var k = 0 ; k < this.dailyCheckItemLists.length ; k++){
                if(String(this.dailyCheckItemLists[k].dailyCheckItemName).length > 30 && this.validation.checkSettingResult ==""){
                    this.validation.checkSettingResult="チェック項目30桁以内で入力してください。"
                    this.addFormFlg = false;
                    break;
                }
            }

            // タイトルテキスト
            if(String(this.dailyCheckPageSettings.dailyCheckPageName).length > 22 && this.validation.titleResult ==""){
                this.validation.titleResult="タイトルは22桁以内で入力してください。"
                this.addFormFlg = false;
            }
        },
        clearError(){
            //メッセージ初期化
            this.validation.displayFlgResult = "";
            this.validation.titleResult = "";
            this.validation.dataResult = "";
            this.validation.manualFilePathResult = "";
            this.validation.informationFilePathResult = "";
            this.validation.checkSettingResult = "";
            this.validation.arrangementFileResult = "";
            this.validation.startDataResult = "";
            this.validation.allButtonDisplayFlgResult = "";
        },
        scrollTop() {
            window.scrollTo(0,0);
        },
        releaseDayDelete(){
            this.showContentKbn = 3;
            this.showContent2 = true;
        },
        releaseDayUpAdd(){
            // バリデーションチェック
            this.validationCheck();
            if(!this.addFormFlg){
                this.scrollTop();
                return null;
            }

            var Kbn = false;
            this.updateKbn = 0 ;
            // 入力状態で判定を実施
            // 履歴内に存在する場合は、更新として扱う。
            var dateFor = this.selectDateFormat(this.date)
            for(var i = 0 ; i < this.releaseHistories.length ; i++){
                if(dateFor === this.releaseHistories[i].replace(/-/g,"/")){
                    Kbn = true;
                    this.updateKbn = 1;
                    break;
                }
            }
            // フラグ判定
            if(Kbn){
                this.showContentKbn = 2;
            }
            else{
                this.showContentKbn = 1;
            }
            this.showContent2 = true;

        },
        closeModelDelete(){
            this.showContent2 = false;
        },
        async delModel(){

            this.isLoading = true;
            var apiResponseFlg = true;
            this.showContent2 = false;

            // リリース日のチェック
            if(this.applyStartDate !== null){
                if(this.applyStartDate <= this.selectDateFormat(new Date())){
                    this.validation.startDataResult="過去のリリース日履歴は削除出来ません。";
                    this.isLoading = false;
                    return null;
                }
            }

            // request作成
            var requestBody = {
                apply_start_date: this.applyStartDate
            }
            var formRequestBody = this.jsonToFormData(requestBody);

            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data;'
                }
            }

            // メニューページ情報削除API
            await this.$axios
                .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/page/' + this.id + "/delete", formRequestBody, config)
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        // APIのエラー情報をerrorに入れる
                        error = Object.assign(error, err.customError)
                        // エラーコードが400であればバリデーションエラーなので画面に表示する
                        if (error.code == 400) {
                            this.apivalidationMessage = error.message
                            this.scrollTop();
                        }
                    }
                    if (this.apivalidationMessage == '') {
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            if(apiResponseFlg){
                this.showContent3 = true;
            }
        },
        closeModelComp(){
            this.showContent3 = false;
            // 削除の場合、画面を初期化する。
            if(this.showContentKbn == 3){
                // 削除の場合、リリース日の指定は初期化する
                this.applyStartDate = null;
            }

            // 初期化処理
            this.calc();

            // パラメータ初期化
            this.showContentKbn = null;
            this.manualFile = null;
            this.informationFile = null;
            this.arrangementFile = null;
            this.$refs.manual.value = '';
            this.$refs.information.value = '';
            this.$refs.arrangement.value = '';
        },
        selectDateFormat(date){
            let year = date.getFullYear();
            let month = ("0" + (date.getMonth()+1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);

            let format_str = 'YYYY/MM/DD';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);

            return format_str;
        },
        init(){
            // 画面の初期化
            this.calc();
        },
        selectOn(){
            // 曜日 すべて押下時
            if(this.weekSelect.allSelected){
                // On
                this.weekDisplayFlg.sunday = true;
                this.weekDisplayFlg.monday = true;
                this.weekDisplayFlg.tuesday = true;
                this.weekDisplayFlg.wednesday = true;
                this.weekDisplayFlg.thursday = true;
                this.weekDisplayFlg.friday = true;
                this.weekDisplayFlg.saturday = true;
            }
            else{
                // Off
                this.weekDisplayFlg.sunday = false;
                this.weekDisplayFlg.monday = false;
                this.weekDisplayFlg.tuesday = false;
                this.weekDisplayFlg.wednesday = false;
                this.weekDisplayFlg.thursday = false;
                this.weekDisplayFlg.friday = false;
                this.weekDisplayFlg.saturday = false;
            }
        },
        checkDateBusinessDay(){
            let minAllowedDay = new Date();
            let hours = ("0" + minAllowedDay.getHours()).slice(-2);

            // AM00-AM03時の判定
            if(hours >= '03' && hours <= '23'){
                minAllowedDay.setDate(minAllowedDay.getDate() +1);
            }
            return new Date(minAllowedDay.getFullYear(),minAllowedDay.getMonth(),minAllowedDay.getDate());
        },
        chartDateBusinessDay(date){

            let year = date.getFullYear();
            let month = ("0" + (date.getMonth()+1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);
            let hours = ("0" + date.getHours()).slice(-2);

            // AM00-AM03時の判定
            if(hours >= '00' && hours < '03'){

                // 年始の考慮
                if(month == '01' && day == '01'){
                    var yearEndDate = new Date(date.getFullYear()-1,12,0);
                    year = date.getFullYear()-1;
                    month = 12;
                    day = ("0" + yearEndDate.getDate()).slice(-2);

                }
                // 月末の考慮
                else if(day == '01'){
                    var monthEndDate = new Date(date.getFullYear(),date.getMonth(),0);
                    month = ("0" + (date.getMonth())).slice(-2);
                    day = ("0" + monthEndDate.getDate()).slice(-2);
                }
                // 前日日付の営業日
                else{
                    var dayBeforeDate = new Date(date.getFullYear(),date.getMonth()+1,date.getDate()-1);
                    day =  ("0" + dayBeforeDate.getDate()).slice(-2);
                }
            }

            let format_str = 'YYYY/MM/DD';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);

            return format_str;
        },
        commentDisplayFlgToggle:function (dailyCheckItemNo) {
          switch (this.dailyCheckItemLists[dailyCheckItemNo-1].commentDisplayFlg) {
            case 0:
              this.dailyCheckItemLists[dailyCheckItemNo-1].commentDisplayFlg = 1;
              break;
            case 1:
              this.dailyCheckItemLists[dailyCheckItemNo-1].commentDisplayFlg = 0;
              break;
          }
        },
        clickAlertSetting:function (index) {
          this.selectIndex = index;
          this.alertSetting = this.dailyCheckItemLists[this.selectIndex].alertSetting
          this.showContent4 = true;
        },
        closeAlertSettingModel:function () {
          this.showContent4 = false;
        },
        clickLumpAlertSetting:function () {
          this.selectIndex = null;
          this.alertSetting = this.lumpAlertSetting;
          this.showContent4 = true;
        },
        changeFormat() {
          var week = this.weekdays.find(item => item.value == this.alertSetting.weekday).text;
          var day = this.monthdays.find(item => item.value == this.alertSetting.monthday).text;
          switch (this.alertSetting.repeat_type) {
            case 0:
              this.alertSetting.format = '毎日 '+this.alertSetting.time;break;
            case 1:
              this.alertSetting.format = '毎週 '+week+"曜日 "+this.alertSetting.time;break;
            case 2:
              if(this.alertSetting.monthday_second == null){
                this.alertSetting.format = '毎月 '+day+" "+this.alertSetting.time;break;
              } else {
                var day2 = this.monthdays.find(item => item.value == this.alertSetting.monthday_second).text;
                this.alertSetting.format = '毎月 '+day+" "+day2+" "+this.alertSetting.time;break;
              }
          }
        },
        setAlertSetting() {
          if(this.isLump){
            for(var j =0 ; j < this.dailyCheckItemLists.length ; j++){
              this.dailyCheckItemLists[j]['alertSetting'] = {
                format: this.lumpAlertSetting.format,
                isSet: this.lumpAlertSetting.isSet,
                time: this.lumpAlertSetting.time,
                repeat_type: this.lumpAlertSetting.repeat_type,
                weekday: this.lumpAlertSetting.weekday,
                monthday: this.lumpAlertSetting.monthday,
                monthday_second: this.lumpAlertSetting.monthday_second,
              };
            }
          } else {
            this.dailyCheckItemLists[this.selectIndex]['alertSetting'] = {
              format: this.alertSetting.format,
              date: null,
              isSet: this.alertSetting.isSet,
              time: this.alertSetting.time,
              repeat_type: this.alertSetting.repeat_type,
              weekday: this.alertSetting.weekday,
              monthday: this.alertSetting.monthday,
              monthday_second: this.alertSetting.monthday_second,
            };
          }
          this.showContent4 = false;

        },
        clearMonthday() {
          if(this.isLump){
            this.lumpAlertSetting.monthday_second = null;
          } else {
            this.alertSetting.monthday_second = null;
          }
          this.changeFormat();
        },
        chengIsLump() {
          if(this.isLump && this.dailyCheckPageSettings.displayFlg == 1){
            this.lumpAlertSetting.isSet = 1
            for(var j =0 ; j < this.dailyCheckItemLists.length ; j++){
              this.dailyCheckItemLists[j]['alertSetting']['isSet'] = 1;
            }
          }
        },
        settingFormat(repeat_type, weekday,monthday,monthday_second,time) {
          var format = "毎日 00:00";
          var week = this.weekdays.find(item => item.value == weekday).text;
          var day = this.monthdays.find(item => item.value == monthday).text;
          switch (repeat_type) {
            case 0:
              format = '毎日 '+time;break;
            case 1:
              format = '毎週 '+week+"曜日 "+time;break;
            case 2:
              if(monthday_second == null){
                format = '毎月 '+day+" "+time;break;
              } else {
                var day2 = this.monthdays.find(item => item.value == monthday_second).text;
                format = '毎月 '+day+" "+day2+" "+time;break;
              }
          }
          return format;
        },
        selectDisplaySetting() {
          for(var j =0 ; j < this.dailyCheckItemLists.length ; j++){
            this.dailyCheckItemLists[j]['alertSetting']['isSet'] = 0;
          }
        }
    }
}
</script>